<template>
  <div class="textcolours">

    <div v-if="orgEvents.length > 0" class="col-md-12" align="center">
      <h3 style="font-size:1.75rem; font-weight:500" :style="{color: event.textcolour}">Check out the other events we have
        <div class="filter-btn">
        <a :href="`/organisation/${event.organisation_id}/events`" class="el-button el-button--primary el-popover__reference" target="_blank" :style="{'background-color': event.buttoncolour, 'border-color': event.buttoncolour}">All Our Events</a>
        <el-popover placement="bottom" title="Filter By Event Tags" width="250" trigger="click">
          <el-select v-model="tagsSelected" multiple placeholder="Select Tags" @change="getEvents">
            <el-option v-for="item in tagsList" :key="item.value " :label="item.label" :value="item.value ">
            </el-option>
          </el-select>
          <el-button slot="reference" type="primary" icon="fa fa-filter" style="margin-left: 10px;" :style="{'background-color': event.buttoncolour, 'border-color': event.buttoncolour}"> Click to filter by tags</el-button>
        </el-popover>
        </div>
      </h3>

      <hr style="width: 80%; height: 1px; background-color: #ff9500; " :style="{ 'background-color': event.phcolour} " />

    </div>
        <div v-if="orgEvents.length > 0" class="events">
          <event-deck :events="orgEvents"></event-deck>
        </div>
    </div>

</template>

<script>

import eventDeck from "@/splash/events-card-deck.vue"
export default {
  data() {
    return {
      imageBucket: window.imageBucket,
      orgEvents: [],
      tagsSelected: [],
      tagsList: [],
      loading: false,
      tags: []
    };
  },

  props: ["event", "isPreview"],

  computed: {
    orderEventsByStartDate() {
      if (this.orgEvents.length == 0) return this.orgEvents;
      return this.orgEvents.sort(
        (a, b) => new Date(a.datetimefrom) - new Date(b.datetimefrom)
      );
    }
  },

  watch: {
    event: {
      handler(val){
        if(this.isPreview){
          this.showEventPreview();
        }
      },
      deep: true
    }
  },

  created() {
    var self = this;
    if (!this.event.phcolour) {
      this.event.phcolour = "rgba(255, 149, 0, 0.86)";
    }

    if(this.isPreview){
      this.showEventPreview();
    } else {
      this.$http
      .get(`/get_all_org_tags/${this.event.organisation_id}`, {
        params: {
              event_id: self.event.id
        }
      })
      .then(function(response) {
        response.data.tags.forEach(tag => {
          self.tags.push(tag);
          self.tagsList.push({ value: tag, label: tag });
        });
      });

      this.getEvents();
    }

  },

  components: {
    eventDeck: eventDeck
  },

  methods: {
    getEvents() {
      var self = this;
      this.$http
        .get("/get_all_events/" + this.event.organisation_id, {
          params: {
            event_id: self.event.id,
            tags: self.tagsSelected
          }
        })
        .then(function(response) {
          self.orgEvents = response.data.events;
          self.setOrgEventUrls();
        });
    },

    showEventPreview() {
      console.log("showEventPreview() called");
      var self = this;
      this.$http
        .get(`/preview_event_card/${this.event.id}.json`)
        .then(function(response) {
          self.orgEvents = [];
          self.orgEvents.push(response.data);
          self.setOrgEventUrls();
        });
    },

    setOrgEventUrls() {
      var self = this;
      self.orgEvents.forEach(function(event) {
        if (event.image2) {
          event.imageFileURL =
            "https://s3-eu-west-1.amazonaws.com/" +
            self.imageBucket +
            "/" +
            event.id +
            "/" +
            event.image2 +
            "?" +
            Math.random();
        }
        if (event.custom_url) {
          event.eventurl = "/" + event.custom_url;
        } else {
          event.eventurl =
            "/event/" +
            event.id +
            "/" +
            event.title.toLowerCase().replace(/[\\!&|?$%@':;.<>/"=+\s]/g, '_');
        }
      });
    }
  }
};
</script>

<style scoped>
.textcolours {
  color: black !important;
}
</style>
